import React from "react";

import TemplateBlock from "../../../../frontend/templates/_partials/TemplateBlock/Index";
import ResultOverlay from "../../../../frontend/templates/fcb/ResultsNew/ResultOverlay";
import { bottomScrimStyle, formatFromRatio } from "../../../../frontend/templates/fcb/ResultsNew/helpers";
import { dfbPokalId, uefaID } from "../../../../frontend/templates/fcb/ImageTable/Index";

// The editor canvas paints its own draggable background layers, so the only
// thing this preview contributes is what sits on top of them. It is rendered at
// the template's real pixel size inside `.template-container`, which the editor
// stylesheet then scales down (0.319 / 0.409) — the same approach
// tableContent.js uses. Nothing here restates the template's sizing: every
// value still comes from ResultsNew/style/style.scss, so the preview and the
// exported image can no longer drift apart.
const FCBResultContent = ({ data, manualEntries, time, isPenalty, ratio, hasBackground, scrimHeight }) => {
    const format = formatFromRatio(ratio);
    const isUEFA = data?.event?.competitionId === uefaID;
    const isDFBPokal = data?.event?.competitionId === dfbPokalId;

    return (
        <div className={`comp-template-preview result-template-preview f-${format}`}>
            <div className="template-container">
                {/* `transparent-background` keeps the template's opaque black
                    backdrop from hiding the layers underneath. */}
                <div className={`T_${data?.template_name || "fcb_results"} resultTemplate transparent-background`}>
                    <TemplateBlock>
                        {/* Empty of layers — the editor draws those itself — but it
                            still carries the template's bottom scrims (the
                            `.custom-background-container::after` gradient and the
                            heavier ramp below) and, for UEFA and DFB-Pokal
                            matches, the competition gradient. Keeping them here rather than
                            beside the canvas preserves the order they paint in,
                            and pins the ramp to the frame the way the export
                            does — the canvas layers underneath can be dragged
                            anywhere without dragging it along. */}
                        <div className={"custom-background-container"}>
                            {isUEFA && <div className="ucl-gradient"></div>}
                            {isDFBPokal && <div className="dfb-gradient"></div>}
                            <div className={"custom-background"}></div>
                            {hasBackground && <div style={bottomScrimStyle(scrimHeight)} />}
                        </div>

                        <ResultOverlay
                            data={data}
                            manualEntries={manualEntries}
                            time={time}
                            isPenalty={isPenalty}
                            showMultiline={format === "1920x1080"}
                        />
                    </TemplateBlock>
                </div>
            </div>
        </div>
    );
};

export default FCBResultContent;
